const initialState = {
  tables: [],
  loading: true,
  error: null
};

export const tablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_TABLES_START':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'FETCH_TABLES_SUCCESS':
      return {
        ...state,
        tables: action.payload,
        loading: false,
        error: null
      };
    case 'FETCH_TABLES_ERROR':
      console.log('>>> action.payload', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case 'CLEAR_TABLES_ERROR':
      return {
        ...state,
        error: null
      };
    default:
      return state;
  }
};